import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { categoryCount } from '@/utils/video';

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950">发现兴趣分类</h2>
          <p className="text-sm text-foreground-500 mt-1.5">总有一个领域，能戳中你的快乐</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.map((c) => (
          <Link
            key={c.key}
            to={`/category/${c.key}`}
            className="group relative rounded-lg overflow-hidden aspect-[4/3] cursor-pointer bg-secondary-100"
          >
            <img
              src={c.cover}
              alt={`${c.name}分类 - 抖音短视频`}
              title={`${c.name}分类 - 抖音短视频`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <p className="text-background-50 font-bold text-base">{c.name}</p>
                <p className="text-background-100/80 text-xs">{categoryCount(c.key)} 个视频</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}